export const scoreColor = (score) => {
  if (score < 40) return "#ff3b5c";
  if (score < 75) return "#ffb000";
  return "#22e58a";
};

export const scoreBand = (score) => {
  if (score < 40) return "HIGH RISK";
  if (score < 75) return "NEEDS WORK";
  return "LAUNCH READY";
};

export const Gauge = ({ score = 0, size = 260 }) => {
  const stroke = 16;
  const r = (size - stroke) / 2;
  const cx = size / 2;
  const cy = size / 2;
  const startAngle = Math.PI;
  const endAngle = 0;
  const angle = startAngle - (score / 100) * Math.PI;

  const point = (a) => [cx + r * Math.cos(a), cy - r * Math.sin(a)];
  const [sx, sy] = point(startAngle);
  const [ex, ey] = point(endAngle);
  const [px, py] = point(angle);

  const color = scoreColor(score);
  const filledLarge = score > 50 ? 1 : 0;
  const gid = `g-${score}`;

  return (
    <div className="flex flex-col items-center" data-testid="score-gauge">
      <svg width={size} height={size / 2 + 30} viewBox={`0 0 ${size} ${size / 2 + 30}`}>
        <defs>
          <linearGradient id={gid} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={color} stopOpacity="0.55" />
            <stop offset="100%" stopColor={color} />
          </linearGradient>
          <filter id="glow">
            <feGaussianBlur stdDeviation="4" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <path
          d={`M ${sx} ${sy} A ${r} ${r} 0 0 1 ${ex} ${ey}`}
          fill="none"
          stroke="rgba(120,200,230,0.12)"
          strokeWidth={stroke}
          strokeLinecap="round"
        />
        <path
          d={`M ${sx} ${sy} A ${r} ${r} 0 ${filledLarge} 1 ${px} ${py}`}
          fill="none"
          stroke={`url(#${gid})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          filter="url(#glow)"
        />
        <circle cx={px} cy={py} r={stroke / 2 + 2} fill={color} filter="url(#glow)" />
        <text
          x={cx}
          y={cy - 4}
          textAnchor="middle"
          fontFamily="'Chakra Petch', sans-serif"
          fontWeight="700"
          fontSize={size * 0.3}
          fill="#E7ECF3"
          style={{ filter: "drop-shadow(0 0 12px " + color + ")" }}
        >
          {score}
        </text>
        <text
          x={cx}
          y={cy + 20}
          textAnchor="middle"
          fontFamily="'JetBrains Mono', monospace"
          fontSize={size * 0.05}
          letterSpacing="3"
          fill="#7A8699"
        >
          / 100 READINESS
        </text>
      </svg>
      <div
        className="mt-1 px-4 py-1.5 font-display text-xs font-bold tracking-[0.25em] rounded-md"
        style={{
          color,
          border: `1px solid ${color}`,
          boxShadow: `0 0 18px ${color}55, inset 0 0 18px ${color}22`,
        }}
        data-testid="score-band"
      >
        {scoreBand(score)}
      </div>
    </div>
  );
};
